import {Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {Util} from '../../../core';
import {LanguagesService} from '../../../core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DialogCloseResult, DialogRef, DialogService} from '@progress/kendo-angular-dialog';

@Component({
  selector: 'gc-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.less']
})
export class MultiSelectComponent implements OnInit {

  constructor(el: ElementRef, public lang: LanguagesService, private dialog: DialogService) {
    this.style = el.nativeElement.getAttribute('style');
  }
  @Input() readonly = false;
  @Input() autocomplete = false;
  @Input() values: any [] = [];
  @Output() valuesChange = new EventEmitter();

  // tslint:disable-next-line:no-output-native
  @Output() focus = new EventEmitter();

  listKendoInternal: {[key: string]: any} [] = [];
  @Input()
  get listKendo(): {[key: string]: any} []{
    return this.listKendoInternal;
  }

  set listKendo(v) {
    this.listKendoInternal = v;
    if (this.listKendoInternal) {
      this.listData = this.listKendoInternal.slice();
    }
  }


  listData: {[key: string]: any} [];
  @Input()
  get list(): any[][] {
    return this.listArrayItems;
  }
  set list(v) {
    this.listArrayItems = v;
    if (v) {
      this.listKendo = Util.toKendoListValues(v, 'multi-select');
    }
  }

  @Input() maxRows = 3;
  @Input() maxCols = 30;
  @Input() simpleMode = true;

  @Output()
  detail: EventEmitter<MultiSelectComponent> = new EventEmitter();

  style = null;
  listArrayItems: any [][];
  moreDialogOpened = false;
  editDialogOpened = false;

  // Internal use list
  srcData: any[] = [];
  desData: any[] = [];
  srcSelected = [];
  desSelected = [];

  ngOnInit(): void {
    if (this.listKendo) {
      this.listData = this.listKendo.slice();
    }
  }

  isCheck(item: any): boolean {
    return this.values && this.values.includes(item);
  }
  findText(value: number): string {
    if (this.listKendo) {
      const index = this.listKendo.findIndex(item => item.value === value);
      if (index > -1 ){
        return this.listKendo[index].text;
      }
    }
    if (value) {
      return value.toString();
    }
    return null;
  }
  reduceText(text: string, length = 20): string {
    if (!text) {
      return  null;
    }
    if (text.length <= length) {
      return text;
    }
    return text.substr(0, length) + ' ...';
  }

  prepare(): void {
    this.editDialogOpened = !this.editDialogOpened;
    if (!this.editDialogOpened) {
      return;
    }
    const src = [];
    const des = [];
    this.srcSelected = [];
    this.desSelected = [];

    if (this.listKendo) {
      this.listKendo.forEach(item => {
        if (this.isCheck(item.value)) {
          des.push(item);
        }else{
          src.push(item);
        }
      });
    }

    // const src = this.listKendo.slice();
    // const des = [];
    // this.values.forEach(value => {
    //   const index = src.findIndex(rec => rec.value = value);
    //   if (index > -1) {
    //     des.push(src[index]);
    //     src.splice(index, 1);
    //   }
    // });
    this.srcData = src;
    this.desData = des;
  }

  selectAll(src, des): void {
    src.forEach(rec => {
      des.push(rec);
    });
    src.splice(0, src.length);
    this.desSelected = [];
    this.srcSelected = [];
  }

  select(keys, src, des): void {
    if (!keys || keys.length < 1) {
      return;
    }
    const result = [];
    src.forEach( rec => {
      if (keys.includes(rec.value)) {
        des.push(rec);
      }else{
        result.push(rec);
      }
    });
    src.splice(0, src.length);
    result.forEach(rec => {
      src.push(rec);
    });
    this.desSelected = [];
    this.srcSelected = [];
  }

  apply(): void {
    const res = [];
    this.desData.forEach(item => {
      res.push(item.value);
    });
    this.values = res;
    this.valuesChange.emit(this.values);
  }

  filterChange(v): void {
    const contains = value => rec => {
      if (!rec.text) {
        return false;
      }
      let ret = rec.text.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      if (!ret && rec.extra1) {
        ret = rec.extra1.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      }
      return ret;
    };
    this.listData = this.listKendo.filter(contains(v));
  }

  public valueNormalizer = (text$: Observable<string>) => text$.pipe(map((text: string) => {
    // search for matching item to avoid duplicates
    const matchingValue: any = this.values.find((item: any) => {
      return item.toString().toLowerCase() === text.toLowerCase();
    });

    if (matchingValue) {
      return matchingValue; // return the already selected matching value and the component will remove it
    }

    // search in data
    const matchingItem: any = this.listKendo.find((item: any) => {
      return item.text.toLowerCase() === text.toLowerCase();
    });

    if (matchingItem) {
      return matchingItem;
    } else {
      return {
        value: text, // generate unique value for the custom item
        text
      };
    }
  }))

  public openDetail(): void {
    if (this.readonly) {
      this.moreDialogOpened = !this.moreDialogOpened;
    }else {
      this.prepare();
    }
    this.detail.emit(this);
  }

  public showDetail(template: TemplateRef<any>): void {
    if (this.readonly) {
      this.dialog.open({
        title: this.lang.define.lib.view,
        content: template,
        actions: [{ text: this.lang.define.lib.close, primary: true }]
      });
    }else {
      this.focus.emit();
      this.prepare();
      const dialog: DialogRef = this.dialog.open({
        title: this.lang.define.lib.edit,
        content: template,
        actions: [{ text: this.lang.define.lib.cancel }, { text: this.lang.define.lib.apply, primary: true }]
      });

      dialog.result.subscribe((result) => {
        if (!(result instanceof DialogCloseResult) && result.primary) {
          this.apply();
        }

      });
    }
  }

  onInputFocus(): void {
    this.focus.emit();
  }
}
